import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import LandingPageContent from "src/components/landing/LandingPageContent";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { SiteContext } from "src/context/site";

const LandingPage = () => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(null);

  const getPageDetails = async () => {
    try {
      const { data } = await apiRequest("GET", "/portal/landing/page");
      setPage(data.data);
    } catch (err) {
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    if (site?._id) {
      if (site?.use_landing_page) {
        getPageDetails();
      } else {
        setIsLoaded(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?._id, site?.use_landing_page]);

  if (!isLoaded)
    return (
      <div className="h-screen w-full items-center justify-center">
        <Preloader className="h-full" />
      </div>
    );

  if (!page?._id) navigate("/login");

  return (
    page?._id && (
      <div className="h-screen w-full font-normal">
        <LandingPageContent
          site={site}
          pageContent={page?.content}
        />
      </div>
    )
  );
};

export default LandingPage;
